import { FormattedMessage } from 'react-intl';
import Tag from '@rio-cloud/rio-uikit/Tag';

import Icon from './Icon';
import { formatDate } from './utils/formatDate';
import { VehicleWarning } from './utils/types';

const Card = ({ warning }: { warning: VehicleWarning }) => (
    <div className="padding-y-15 " data-testid="warning-card">
        <div className="display-flex align-items-start gap-10">
            <Icon criticality={warning.criticality} size={18} />
            <div className="display-flex flex-column gap-2 flex-1-1">
                {warning.messages && (
                    <>
                        <span className="text-medium text-size-14 text-color-darkest">
                            <FormattedMessage id={`intl-msg:vehicle-warnings.warningType.${warning.type}`} />
                            {': '}
                            <FormattedMessage id={warning.messages.description} />
                        </span>
                        <span className="text-color-gray text-size-12">{formatDate(warning.active_in_vehicle_at)}</span>
                        <span className="text-size-14 text-color-darker margin-top-2">
                            <FormattedMessage id={warning.messages.recommendation} />
                        </span>
                        {(warning.messages.tags.info || warning.messages.tags.status) && (
                            <div className="display-flex gap-5 margin-top-5 flex-wrap">
                                {warning.messages.tags.info && (
                                    <Tag size="small" muted>
                                        <FormattedMessage
                                            id={warning.messages.tags.info.id}
                                            values={warning.messages.tags.info.values}
                                        />
                                    </Tag>
                                )}
                                {warning.messages.tags.status && (
                                    <Tag size="small" muted>
                                        <FormattedMessage
                                            id={warning.messages.tags.status.id}
                                            values={warning.messages.tags.status.values}
                                        />
                                    </Tag>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    </div>
);

export default Card;
